/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function QuestionFilled12({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="12"
      role="img"
      viewBox="0 0 12 12"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10Zm-.604-4.086c0-.625.363-.909.835-1.218l.056-.038c.409-.273.774-.517.774-1.044 0-.388-.258-.803-.977-.803-.892 0-1.129.625-1.165 1.223l-.987-.094c.02-1.192.714-2.09 2.178-2.09 1.119 0 1.959.73 1.959 1.701 0 .856-.426 1.192-.909 1.517-.058.04-.115.077-.17.113-.38.249-.649.425-.649.806v.063h-.945v-.136Zm-.089 1.065h1.218V9.15H5.307V7.98Z"
        fill={CssVars.textColor}
        fillRule="evenodd"
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
